module.exports = __webpack_public_path__ + "img/124-d9f8e0.png";